module.exports = __webpack_public_path__ + "media/images/logoaca-cb88ef19af14eacdc2d3f1345751537f.png";